var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.observeVisibilityOptions,
          expression: "observeVisibilityOptions",
        },
      ],
      staticClass: "slick-wrapper",
    },
    [
      _c(
        "slick",
        {
          ref: _vm.ref,
          class: _vm.className,
          attrs: { options: _vm.slickOptions },
          on: {
            beforeChange: _vm.handleBeforeChange,
            afterChange: _vm.handleAfterChange,
          },
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            { key: _vm.rand + index },
            [_vm._t("slide-card", null, { item: item, index: index })],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }